export default class WorkflowProgressRepositoryError extends Error {
    constructor(code, message, details = {}) {
        super(message)

        this.name = 'WorkflowProgressRepositoryError'
        this.code = code
        this.details = details
    }
}
